import { api } from "@/lib/api";

export const getSolanaOverview = () =>
  api.get("/ecosystems/solana").then((r) => r.data);

export const getSolanaAssets = (params = {}) =>
  api.get("/ecosystems/solana/assets", { params }).then((r) => r.data);

export const getSolanaLeaderboard = (params = {}) =>
  api.get("/ecosystems/solana/leaderboard", { params }).then((r) => r.data);

export const getSolanaHype = (params = {}) =>
  api.get("/ecosystems/solana/hype", { params }).then((r) => r.data);

export const getSolanaCallers = (params = {}) =>
  api.get("/ecosystems/solana/callers", { params }).then((r) => r.data);

export const getSolanaMetrics = () =>
  api.get("/ecosystems/solana/metrics").then((r) => r.data);

export const getSolanaNetwork = () =>
  api.get("/ecosystems/solana/network").then((r) => r.data);

/** Normalize FastAPI / axios error payloads into a renderable string. */
export function formatSolanaApiError(err, fallback = "Failed to load Solana ecosystem") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const parts = detail
      .map((item) => {
        if (typeof item === "string") return item;
        if (item && typeof item.msg === "string") return item.msg;
        try {
          return JSON.stringify(item);
        } catch {
          return null;
        }
      })
      .filter(Boolean);
    if (parts.length) return parts.join("; ");
  }
  if (detail != null && typeof detail === "object") {
    try {
      return JSON.stringify(detail);
    } catch {
      /* fall through */
    }
  }
  if (typeof err?.message === "string" && err.message.trim()) return err.message;
  return fallback;
}

/** Truncate a Solana mint address for display. */
export function shortMint(addr) {
  if (addr == null) return "";
  const s = String(addr);
  if (s.length < 12) return s;
  return `${s.slice(0, 6)}…${s.slice(-4)}`;
}

/** Solscan token URL for a mint address. */
export function explorerMintUrl(mint) {
  if (!mint) return null;
  return `https://solscan.io/token/${mint}`;
}
